var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"frame-puzzle-close-buttons"}},[_c('font-awesome-icon',{staticClass:"rv-close",attrs:{"icon":"times","size":"2x"},on:{"click":_vm.onClose}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }